import { ReportStatsTotalObj } from '@crm/api'
import { DescriptionLabel } from '@crm/components'
import { Card, Statistic } from 'antd'

import { ArrowDown, ArrowUp } from 'iconsax-react'

import type { CardProps } from 'antd'

type Props = {
  title: string
  value?: ReportStatsTotalObj
} & CardProps

export const TotalReportsCard = ({ title, value, ...props }: Props) => {
  const statisticValue = {
    color:
      value?.relative_diff && value.relative_diff < 0 ? '#cf1322' : '#3f8600',
    icon:
      value?.relative_diff && value.relative_diff < 0 ? (
        <ArrowDown size={26} />
      ) : (
        <ArrowUp size={26} />
      )
  }

  return (
    <Card size="small" {...props}>
      <Statistic
        title={
          <DescriptionLabel label={title} info={value?.current} vertical />
        }
        value={value?.relative_diff}
        valueStyle={{
          color: statisticValue?.color,
          display: 'flex',
          justifyContent: 'end'
        }}
        prefix={statisticValue?.icon}
        suffix="%"
      />
    </Card>
  )
}
